<script>
  import classnames from 'classnames';
  export let active = false;
</script>

<span class={classnames('chevron-down', { 'is-active': active })} />

<style lang="scss">
  .chevron-down {
    width: 15px;
    height: 15px;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;

    border-top: 5px solid #ddd;
    position: relative;
    top: 10px;
  }

  .chevron-down:hover,
  .chevron-down.is-active {
    border-top-color: #aaa;
  }
</style>
